export var POPUP_CONDITION = /* @__PURE__ */ ((POPUP_CONDITION2) => {
  POPUP_CONDITION2["URL"] = "url";
  POPUP_CONDITION2["PATH_SEGMENT"] = "pathSegment";
  POPUP_CONDITION2["KEYWORD"] = "keyword";
  POPUP_CONDITION2["QUERY_PARAM"] = "queryParam";
  return POPUP_CONDITION2;
})(POPUP_CONDITION || {});
export var POPUP_RULE_ACTION = /* @__PURE__ */ ((POPUP_RULE_ACTION2) => {
  POPUP_RULE_ACTION2["SHOW"] = "show";
  POPUP_RULE_ACTION2["HIDE"] = "hide";
  return POPUP_RULE_ACTION2;
})(POPUP_RULE_ACTION || {});
